<script>
import { number } from "@coders-tm/vue-number-format";
import { required } from "vuelidate/lib/validators";
import { extend } from "vee-validate";
import Swal from "sweetalert2";
import CompanyAPI from "@/services/company/companyAPI";
import CommitteeAPI from "@/services/standards/committee/committeeGreater10API";
import ActAPI from "@/services/standards/committee/acts/actAPI";
import CandidatesCommitteeAPI from "@/services/standards/committee/candidates/candidatesAPI";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";

/**
 * This validation verifies that the number of assistants entered is in the correct range.
 */
extend("positive", {
  validate(value, { args }) {
    if (value >= 10 && value <= 50) {
      if (value >= 10 && value <= args) {
        return true;
      } else false;
    } else false;
  },
  params: ["args"],
  message: (fieldName, placeholders) => {
    return `El ${fieldName} debe ser mayor o igual a 10 y menor o igual a la cantidad de empleados en la empresa`;
  },
});

export default {
  components: {
    number,
  },
  props: {
    companyID: {
      type: Number,
      default: 0,
    },
    committeeID: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      submitted: false,
      exist: false,
      number: {
        separator: ".",
        precision: 0,
        masked: false,
        min: 0,
        max: 50,
        minimumFractionDigits: 0,
        nullValue: 0,
      },
      file: null,
      coexistenceAct: {
        announcement_date: null,
        coexistence_place: null,
        coexistence_begin_hour: null,
        coexistence_ending_hour: null,
        number_assistants: 0,
        certificate: null,
        companies_id: null,
        coexistence_start_date: "2022-07-16",
        coexistence_end_date: "2022-07-16",
      },
      postulatesNumber: 10,
      postulates: [],
      company: this.$store.getters["company/getCompany"].nit || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      lastId: 1,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      loading1: true,
      item: null,
      itemData: null,
      certificateExist: false,
      candidates: [],
      employees: [],
      positions: [
        {
          id: 1,
          name: "REPRESENTANTE EMPLEADOS",
        },
        {
          id: 2,
          name: "SUPLENTE REPRESENTANTE EMPLEADOS",
        },
      ],
      positionsEmployer: [
        {
          id: 3,
          name: "DESIGNADO EMPLEADOR PRINCIPAL",
        },
        {
          id: 4,
          name: "DESIGNADO EMPLEADOR SUPLENTE",
        },
      ],
      employer: [],
      candidatesSelect: [],
      employerCandidates: [],
    };
  },
  validations: {
    coexistenceAct: {
      announcement_date: {
        required,
      },
      coexistence_place: {
        required,
      },
      coexistence_begin_hour: {
        required,
      },
      coexistence_ending_hour: {
        required,
      },
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(8)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID = this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },


    download() {
      if (this.certificateExist) {
        window.location.href = this.coexistenceAct.certificate;
      }
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 8)
        .then((response) => {
          try {
            this.item = response || null;
          } catch (error) {
            console.log(error);
            this.item = null;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * This method is called to show just the name file.
     */
    getFile(file) {
      const name = file.split('/')
      return name[name.length - 1]
    },

    /**
     * This method is called when the user clicks on the button to upload the ARL certificate.
     */
    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    /**
     * This method is used to upload the ARL certificate to Digital Ocean.
     */
    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/1.1.8/acta_conformación_comité_convivencia/${this.$route.params.id}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/1.1.8/acta_conformación_comité_convivencia/${this.$route.params.id}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.coexistenceAct.certificate = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * This method is used to print the Committee act.
     * Is necessary that postulates are loaded.
     */
    print() {
      if (this.postulates.length > 0 || this.employer.length > 0) {
        let postulates = [];

        this.postulates.forEach((postulate) => {
          if (postulate.employee_id) {
            postulates.push(postulate);
          }
        });

        let employer = [];

        this.employer.forEach((emp) => {
          if (emp.employee_id) {
            employer.push(emp);
          }
        });

        if (postulates.length < 4) {
          Swal.fire({
            title: "¡Alerta!",
            text: "¡Debe seleccionar al menos cuatro postulados!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          return;
        }

        if (employer.length < 2) {
          Swal.fire({
            title: "¡Alerta!",
            text: "¡Debe seleccionar al menos dos designados empleador!",
            icon: "warning",
            type: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          return;
        }

        function objectsRepeated(array) {
          for (var i = 1; i < array.length; i++) {
            for (var j = 0; j < i; j++) {
              if (array[i].employee_id === array[j].employee_id) {
                return true;
              }
            }
          }
          return false;
        }

        function statusRepeated(array) {
          for (var i = 1; i < array.length; i++) {
            for (var j = 0; j < i; j++) {
              if (
                array[i].coexistence_status === array[j].coexistence_status &&
                (array[i].coexistence_status === 3 ||
                  array[i].coexistence_status === 4)
              ) {
                return true;
              }
            }
          }
          return false;
        }

        function max2(array) {
          let max = 0;

          for (var i = 1; i < array.length; i++) {
            for (var j = 0; j < i; j++) {
              if (
                array[i].coexistence_status === array[j].coexistence_status &&
                (array[i].coexistence_status === 3 ||
                  array[i].coexistence_status === 4)
              ) {
                max = max + 1;
                if (max >= 2) {
                  return true;
                }
              }
            }
          }
          return false;
        }

        if (objectsRepeated(postulates)) {
          Swal.fire({
            title: "¡Alerta!",
            text: "¡No puede haber postulantes repetidos!",
            icon: "warning",
            type: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          return;
        }

        if (objectsRepeated(employer)) {
          Swal.fire({
            title: "¡Alerta!",
            text: "¡No puede haber designados repetidos!",
            icon: "warning",
            type: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          return;
        }

        if (this.coexistenceAct.number_assistants < 20) {
          if (statusRepeated(employer)) {
            Swal.fire({
              title: "¡Alerta!",
              text: "¡No puede haber colaboradores con cargos repetidos en la lista de designados!",
              type: "warning",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            return;
          }
        } else {
          if (statusRepeated(employer)) {
            Swal.fire({
              title: "¡Alerta!",
              text: "¡No puede haber colaboradores más de dos cargos repetidos en la lista de designados!",
              type: "warning",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            return;
          }
        }
      } else {
        Swal.fire({
          title: "¡Alerta!",
          text: "¡Debe indicar la cantidad de postulantes!",
          type: "warning",
          icon: "warning",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
        return;
      }
    },

    /**
 * This method is used to know the number of employees in the company.
 */
    getEmployees() {
      CompanyAPI.employeesCount(this.companyID)
        .then((response) => {
          this.employees = response.companies.employees_count || 0;
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getLastId() {
      ActAPI.get(this.companyID, '')
        .then((resp) => {
          if (resp.message[0]['id']) {
            this.lastId = resp.message[0]['id'] + 1
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to save the all data of the Committee act.
     * This includes the header Committee act, the postulates and the employers involved.
     */
    async save() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let response = false;
        if (this.committeeID !== 0) {
          this.loading1 = true;
          response = await this.uploadDocument();
          if (response) {
            let postulates = [];

            this.postulates.forEach((postulate) => {
              if (postulate.employee_id) {
                postulates.push(postulate);
              }
            });

            let employer = [];

            this.employer.forEach((emp) => {
              if (emp.employee_id) {
                employer.push(emp);
              }
            });

            function objectsRepeated(array) {
              for (var i = 1; i < array.length; i++) {
                for (var j = 0; j < i; j++) {
                  if (array[i].employee_id === array[j].employee_id) {
                    return true;
                  }
                }
              }
              return false;
            }

            function statusRepeated(array) {
              for (var i = 1; i < array.length; i++) {
                for (var j = 0; j < i; j++) {
                  if (
                    array[i].coexistence_status ===
                    array[j].coexistence_status &&
                    (array[i].coexistence_status === 3 ||
                      array[i].coexistence_status === 4)
                  ) {
                    return true;
                  }
                }
              }
              return false;
            }

            function counterRepeated(array, status) {
              let counter = 0;
              for (var i = 1; i < array.length; i++) {
                for (var j = 0; j < i; j++) {
                  if (
                    array[i].coexistence_status ===
                    array[j].coexistence_status &&
                    (array[i].coexistence_status === status[0] ||
                      array[i].coexistence_status === status[1])
                  ) {
                    counter++;
                  }
                }
              }
              return counter;
            }

            function counter(array, status) {
              let counter = 0;
              for (var i = 0; i < array.length; i++) {
                if (array[i].coexistence_status === status) {
                  counter++;
                }
              }
              return counter;
            }

            if (objectsRepeated(postulates)) {
              this.loading1 = false;
              Swal.fire({
                title: "¡Alerta!",
                text: "¡No puede haber postulantes repetidos!",
                type: "warning",
                icon: "warning",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              return;
            }

            if (objectsRepeated(employer)) {
              this.loading1 = false;
              Swal.fire({
                title: "¡Alerta!",
                text: "¡No puede haber designados repetidos!",
                type: "warning",
                icon: "warning",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              return;
            }

            if (
              this.employees < 20 &&
              (counterRepeated(postulates, [1, 2]) !== 0 ||
                counterRepeated(employer, [3, 4]) !== 0)
            ) {
              this.loading1 = false;
              Swal.fire({
                title: "¡Alerta!",
                text: "No puede haber cargos repetidos!",
                type: "warning",
                icon: "warning",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              return;
            }

            if (
              this.employees >= 20 &&
              (counter(postulates, 1) !== 2 ||
                counter(postulates, 2) !== 2 ||
                counter(employer, 3) !== 2 ||
                counter(employer, 4) !== 2)
            ) {
              this.loading1 = false;
              Swal.fire({
                title: "¡Alerta!",
                title: "¡Es necesario que existan solo dos cargos por tipo!",
                type: "warning",
                icon: "warning",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              return;
            }

            let president = [];
            let secretary = [];

            this.postulates.forEach((postulate) => {
              if (postulate.president) {
                president.push(postulate);
              }

              if (postulate.secretary) {
                secretary.push(postulate);
              }
            });

            this.employer.forEach((emp) => {
              if (emp.president) {
                president.push(emp);
              }

              if (emp.secretary) {
                secretary.push(emp);
              }
            });

            if (president.length !== 1) {
              this.loading1 = false;
              Swal.fire({
                title: "¡Alerta!",
                text: "¡Debe seleccionar al menos a un presidente!",
                type: "warning",
                icon: "warning",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              return;
            }

            if (secretary.length !== 1) {
              this.loading1 = false;
              Swal.fire({
                title: "¡Alerta!",
                text: "¡Debe seleccionar al menos a un secretario!",
                type: "warning",
                icon: "warning",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              return;
            }

            if (postulates.length < 4) {
              this.loading1 = false;
              Swal.fire({
                title: "¡Alerta!",
                text: "¡Debe seleccionar al menos cuatro postulados!",
                type: "warning",
                icon: "warning",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              return;
            }

            if (employer.length < 2) {
              this.loading1 = false;
              Swal.fire({
                title: "¡Alerta!",
                text: "¡Debe seleccionar al menos dos designados empleador!",
                type: "warning",
                icon: "warning",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              return;
            }

            if (this.exist) {
              this.coexistenceAct.certificate

              CommitteeAPI.updateAct(
                this.coexistenceAct.id,
                this.coexistenceAct
              )
                .then((response) => {
                  if (response.Committee === "Committee updated successfull") {
                    let promises = [];

                    this.postulates.forEach((postulate) => {
                      if (postulate.employee_id) {
                        promises.push(
                          CandidatesCommitteeAPI.updateCandidate(
                            postulate.id,
                            postulate
                          )
                        );
                      }
                    });

                    this.employer.forEach((emp) => {
                      if (emp.employee_id) {
                        promises.push(
                          CandidatesCommitteeAPI.updateCandidate(emp.id, emp)
                        );
                      }
                    });

                    const itemChange = {
                      companies_id: this.companyID,
                      item_id: 8,
                      status: 'Pendiente',
                    };
                    newScoresAPI.calculateScores(itemChange)
                      .then((response) => {
                        this.sendNotification(23, 8, true);
                        setTimeout(() => {
                          Swal.fire({
                            title: "¡Éxito!",
                            text: "¡Se ha actualizado con éxito!",
                            type: "success",
                            icon: "success",
                            confirmButtonClass: "btn btn-confirm mt-2",
                          });
                          this.goBack();
                        }, 1000);
                      })
                      .catch((error) => {
                        this.loading1 = false;
                        Swal.fire({
                          title: "Error",
                          text: "¡No se ha podido registrar!",
                          icon: "error",
                          type: "error",
                          confirmButtonClass: "btn btn-confirm mt-2",
                        });
                        console.log(error);
                      });
                  } else {
                    this.loading1 = false;
                    Swal.fire({
                      title: "¡Error!",
                      text: "¡Problemas actualizando!",
                      icon: "error",
                      type: "error",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                  }
                })
                .catch((error) => {
                  this.loading1 = false;
                  console.log(error);
                });
            } else {
              CommitteeAPI.saveAct(this.coexistenceAct)
                .then((resp) => {
                  if (resp.Committee === "Committee saved successfull") {
                    const committeeID = resp.id;
                    const data = [...postulates, ...employer];
                    data.forEach((postulate) => {
                      postulate.coexistence_committee_id = committeeID;
                    });
                    CandidatesCommitteeAPI.save(data)
                      .then((resp) => {
                        const itemChange = {
                          companies_id: this.companyID,
                          item_id: 8,
                          status: 'Pendiente',
                        };
                        newScoresAPI.calculateScores(itemChange)
                          .then((response) => {
                            this.sendNotification(23, 8, true);
                            setTimeout(() => {
                              Swal.fire({
                                title: "¡Éxito!",
                                text: "¡Se ha registrado con éxito!",
                                type: "success",
                                icon: "success",
                                confirmButtonClass: "btn btn-confirm mt-2",
                              });
                              this.goBack();
                            }, 1000);
                          })
                          .catch((error) => {
                            this.loading1 = false;
                            Swal.fire({
                              title: "Error",
                              text: "¡No se ha podido registrar!",
                              icon: "error",
                              type: "error",
                              confirmButtonClass: "btn btn-confirm mt-2",
                            });
                            console.log(error);
                          });
                      })
                      .catch((err) => {
                        this.loading1 = false;
                        console.log("Error guardando postulados: ", err);
                      });
                  } else {
                    this.loading1 = false;
                    console.log("Error guardando acta Comité", resp);
                  }
                })
                .catch((err) => {
                  this.loading1 = false;
                  console.log("Error al guardar acta Comité: ", err);
                  Swal.fire({
                    title: "¡Error!",
                    text: "¡Problemas registrando!",
                    type: "error",
                    icon: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                });
            }
          } else {
            this.loading1 = false;
            Swal.fire({
              title: "¡Error!",
              text: "¡No se ha podido actualizar!, error documento!",
              type: "error",
              icon: "error",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
          }
        } else {
          let postulates = [];

          this.postulates.forEach((postulate) => {
            if (postulate.employee_id) {
              postulates.push(postulate);
            }
          });

          let employer = [];

          this.employer.forEach((emp) => {
            if (emp.employee_id) {
              employer.push(emp);
            }
          });

          function objectsRepeated(array) {
            for (var i = 1; i < array.length; i++) {
              for (var j = 0; j < i; j++) {
                if (array[i].employee_id === array[j].employee_id) {
                  return true;
                }
              }
            }
            return false;
          }

          function statusRepeated(array) {
            for (var i = 1; i < array.length; i++) {
              for (var j = 0; j < i; j++) {
                if (
                  array[i].coexistence_status ===
                  array[j].coexistence_status &&
                  (array[i].coexistence_status === 3 ||
                    array[i].coexistence_status === 4)
                ) {
                  return true;
                }
              }
            }
            return false;
          }

          function counterRepeated(array, status) {
            let counter = 0;
            for (var i = 1; i < array.length; i++) {
              for (var j = 0; j < i; j++) {
                if (
                  array[i].coexistence_status ===
                  array[j].coexistence_status &&
                  (array[i].coexistence_status === status[0] ||
                    array[i].coexistence_status === status[1])
                ) {
                  counter++;
                }
              }
            }
            return counter;
          }

          function counter(array, status) {
            let counter = 0;
            for (var i = 0; i < array.length; i++) {
              if (array[i].coexistence_status === status) {
                counter++;
              }
            }
            return counter;
          }

          if (objectsRepeated(postulates)) {
            Swal.fire({
              title: "¡Alerta!",
              text: "¡No puede haber postulantes repetidos!",
              type: "warning",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            return;
          }

          if (objectsRepeated(employer)) {
            Swal.fire({
              title: "¡Alerta!",
              text: "¡No puede haber designados repetidos!",
              type: "warning",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            return;
          }

          if (
            this.employees < 20 &&
            (counterRepeated(postulates, [1, 2]) !== 0 ||
              counterRepeated(employer, [3, 4]) !== 0)
          ) {
            Swal.fire({
              title: "¡Alerta!",
              text: "¡No puede haber cargos repetidos!",
              type: "warning",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            return;
          }

          if (
            this.employees >= 20 &&
            (counter(postulates, 1) !== 2 ||
              counter(postulates, 2) !== 2 ||
              counter(employer, 3) !== 2 ||
              counter(employer, 4) !== 2)
          ) {
            Swal.fire({
              title: "¡Alerta!",
              text: "¡Es necesario que existan solo dos cargos por tipo!",
              type: "warning",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            return;
          }

          let president = [];
          let secretary = [];

          this.postulates.forEach((postulate) => {
            if (postulate.president) {
              president.push(postulate);
            }

            if (postulate.secretary) {
              secretary.push(postulate);
            }
          });

          this.employer.forEach((emp) => {
            if (emp.president) {
              president.push(emp);
            }

            if (emp.secretary) {
              secretary.push(emp);
            }
          });

          if (president.length !== 1) {
            Swal.fire({
              title: "¡Alerta!",
              text: "¡Debe seleccionar al menos a un presidente!",
              type: "warning",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            return;
          }

          if (secretary.length !== 1) {
            Swal.fire({
              title: "¡Alerta!",
              text: "¡Debe seleccionar al menos a un secretario!",
              type: "warning",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            return;
          }

          if (postulates.length < 4) {
            Swal.fire({
              title: "¡Alerta!",
              text: "¡Debe seleccionar al menos cuatro postulados!",
              type: "warning",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            return;
          }

          if (employer.length < 2) {
            Swal.fire({
              title: "¡Alerta!",
              text: "¡Debe seleccionar al menos dos designados empleador!",
              type: "warning",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            return;
          }

          if (this.exist) {
            this.loading1 = true;
            CommitteeAPI.updateAct(
              this.coexistenceAct.id,
              this.coexistenceAct
            )
              .then((response) => {
                if (response.Committee === "Committee updated successfull") {
                  let promises = [];

                  this.postulates.forEach((postulate) => {
                    if (postulate.employee_id) {
                      promises.push(
                        CandidatesCommitteeAPI.updateCandidate(
                          postulate.id,
                          postulate
                        )
                      );
                    }
                  });

                  this.employer.forEach((emp) => {
                    if (emp.employee_id) {
                      promises.push(
                        CandidatesCommitteeAPI.updateCandidate(emp.id, emp)
                      );
                    }
                  });

                  const itemChange = {
                    companies_id: this.companyID,
                    item_id: 8,
                    status: 'Pendiente',
                  };
                  newScoresAPI.calculateScores(itemChange)
                    .then((response) => {
                      this.sendNotification(23, 8, true);
                      setTimeout(() => {
                        Swal.fire({
                          title: "¡Éxito!",
                          text: "¡Se ha actualizado con éxito!",
                          type: "success",
                          icon: "success",
                          confirmButtonClass: "btn btn-confirm mt-2",
                        });
                        this.goBack();
                      }, 1500);
                    })
                    .catch((error) => {
                      this.loading1 = false;
                      Swal.fire({
                        title: "Error",
                        text: "¡No se ha podido registrar!",
                        icon: "error",
                        type: "error",
                        confirmButtonClass: "btn btn-confirm mt-2",
                      });
                      console.log(error);
                    });
                } else {
                  this.loading1 = false;
                  Swal.fire({
                    title: "¡Error!",
                    text: "¡Problemas actualizando!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                }
              })
              .catch((error) => {
                this.loading1 = false;
                console.log(error);
              });
          } else {
            this.loading1 = true;
            CommitteeAPI.saveAct(this.coexistenceAct)
              .then((resp) => {
                if (resp.Committee === "Committee saved successfull") {
                  const committeeID = resp.id;
                  const data = [...postulates, ...employer];
                  data.forEach((postulate) => {
                    postulate.coexistence_committee_id = committeeID;
                  });
                  CandidatesCommitteeAPI.save(data)
                    .then((resp) => {
                      this.sendNotification(23, 8, true);
                      setTimeout(() => {
                        Swal.fire({
                          title: "¡Éxito!",
                          text: "¡Se ha actualizado con éxito!",
                          type: "success",
                          icon: "success",
                          confirmButtonClass: "btn btn-confirm mt-2",
                        });
                        this.goBack();
                      }, 1000);
                    })
                    .catch((err) => {
                      this.loading1 = false;
                      console.log("Error guardando postulados: ", err);
                    });
                } else {
                  this.loading1 = false;
                  console.log("Error guardando acta Comité", resp);
                }
              })
              .catch((err) => {
                this.loading1 = false;
                console.log("Error al guardar acta Comité: ", err);
                Swal.fire({
                  title: "¡Error!",
                  text: "¡Problemas registrando!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
              });
          }
        }

      }
    },

    /**
     * This method is used to get the possible candidates.
     * This candidadtes are the employees with contract type 1 and status active.
     * Is require the company ID.
     */
    getCandidates() {
      CandidatesCommitteeAPI.getAllPossibleCandidates(this.companyID)
        .then((response) => {
          this.candidates = response;
          this.candidatesSelect = response;
          this.employerCandidates = response;
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to know if the Committee Act exists.
     * If exists, it will get the data.
     * If not, it will create a new Committee Act.
     */
    getCommittee() {
      if (this.committeeID !== 0) {
        CommitteeAPI.getActById(this.committeeID)
          .then((response) => {
            const committee = response[0] || null;
            this.exist = true;

            if (committee) {
              this.coexistenceAct = committee;

              this.certificateExist = committee.certificate ? true : false;

              this.postulates = committee.coexistence_members.filter(
                (candidate) => candidate.is_distinguished === 0
              );
              this.employer = committee.coexistence_members.filter(
                (candidate) => candidate.is_distinguished === 1
              );

              this.postulates.forEach((postulate) => {
                postulate.is_distinguished = false;
                if (postulate.president === 1) {
                  postulate.president = true;
                } else {
                  postulate.president = false;
                }

                if (postulate.secretary === 1) {
                  postulate.secretary = true;
                } else {
                  postulate.secretary = false;
                }
              });

              this.employer.forEach((emp) => {
                emp.is_distinguished = true;
                if (emp.president === 1) {
                  emp.president = true;
                } else {
                  emp.president = false;
                }

                if (emp.secretary === 1) {
                  emp.secretary = true;
                } else {
                  emp.secretary = false;
                }
              });
              this.loading1 = false;
            } else {
              this.exist = false;
              this.loading1 = false;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.exist = false;
        this.loading1 = false;
      }
    },

    /**
     * This method is used to put the number of rows in the table postulates.
     */
    putPostulatesOnArray(number) {
      this.postulates = [];
      for (let i = 0; i < number; i++) {
        this.postulates.push({
          id: i,
          employee_id: null,
          coexistence_status: null,
          coexistence_votes: 0,
          is_distinguished: false,
          president: false,
          secretary: false,
          coexistence_committee_id: null,
        });
      }
    },

    /**
     * This method is used to put the number of rows in the table employers.
     */
    putEmployerOnArray(number) {
      this.employer = [];
      for (let i = 0; i < number; i++) {
        this.employer.push({
          id: i,
          employee_id: null,
          coexistence_status: null,
          coexistence_votes: 0,
          is_distinguished: true,
          president: false,
          secretary: false,
          coexistence_committee_id: null,
        });
      }
    },

    /**
     * This method validates if the assistants number is correct and then,
     * it will put the number of rows in the postulates table and table employers table.
     */
    getPostulatesNumber() {
      if (!this.exist) {
        if (
          this.coexistenceAct.number_assistants >= 10 &&
          this.employees >= this.coexistenceAct.number_assistants
        ) {
          this.putPostulatesOnArray(10);
          this.putEmployerOnArray(4);
        } else if (
          this.coexistenceAct.number_assistants >= 10 &&
          this.employees < this.coexistenceAct.number_assistants
        ) {
          this.putPostulatesOnArray(0);
          this.putEmployerOnArray(0);
          Swal.fire({
            title: "¡Alerta!",
            text: "¡El número de asistentes es mayor al número de empleados!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        } else {
          this.putPostulatesOnArray(0);
          this.putEmployerOnArray(0);
          Swal.fire({
            title: "¡Alerta!",
            text: "¡El número de asistentes tiene que ser mayor a diez!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }
      }
    },

    getPositions() {
      let positions = [
        "REPRESENTANTE EMPLEADOS",
        "SUPLENTE REPRESENTANTE EMPLEADOS",
      ];
      this.positions = this.postulates.map((postulate) =>
        this.positions.filter(
          (position) => position != postulate.coexistence_status
        )
      );
    },

    /**
     * This method is used to go back to the previous page.
     */
    goBack() {
      this.$router.go(-1);
    },

    filterOptions(id) {
      this.candidatesSelect = this.candidates.filter(
        (candidate) =>
          this.postulates.filter(
            (postulate) => postulate.employee_id === candidate.id
          ).length === 0
      );
    },

    filterEmployerOptions(id) {
      this.employerCandidates = this.candidates.filter(
        (candidate) =>
          this.employer.filter(
            (employer) => employer.employee_id === candidate.id
          ).length === 0
      );
    },

    getName(id) {
      if (id) {
        return this.candidates.find((candidate) => candidate.id === id).full_name;
      } else {
        return "";
      }
    },

    onlyOnePresident(array, counterpart, id) {
      array.forEach((postulate) => {
        if (postulate.president) {
          postulate.president = false;
        }
      });
      counterpart.forEach((postulate) => {
        if (postulate.president) {
          postulate.president = false;
        }
      });
      array.find((postulate) => postulate.id === id).president = true;
    },

    onlyOneSecretary(array, counterpart, id) {
      array.forEach((postulate) => {
        if (postulate.secretary) {
          postulate.secretary = false;
        }
      });
      counterpart.forEach((postulate) => {
        if (postulate.secretary) {
          postulate.secretary = false;
        }
      });
      array.find((postulate) => postulate.id === id).secretary = true;
    },
  },
  mounted() {
    this.getCandidates();
    this.getEmployees();
    this.getCommittee();
    this.getItemData();
  },
};
</script>

<template>
  <div class="row">
    <div class="col-md-12">
      <div v-if="!loading1">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 text-right m-b-0">
                <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                  <i class="fas fa-arrow-left"></i>
                </div>
                <b-tooltip target="back" placement="left"> Volver </b-tooltip>
              </div>
            </div>

            <hr />
            <form @submit.prevent="save" class="form-group">
              <div class="form-row pt-3">
                <b-form-group class="col-md-6 px-2" label="Fecha" label-for="announcementDate">
                  <b-form-input :disabled="!allowAccess() ||
                    (!(getRole('Crear') && committeeID === 0) &&
                      !(getRole('Editar') && committeeID !== 0))
                    " type="date" id="announcementDate" v-model="coexistenceAct.announcement_date" :class="{
                      'is-invalid':
                        $v.coexistenceAct.announcement_date.$error && submitted,
                    }">
                  </b-form-input>
                  <div v-if="submitted && $v.coexistenceAct.announcement_date.$error
                  ">
                    <small v-if="!$v.coexistenceAct.announcement_date.required" class="text-danger">
                      <b>La fecha del acta de conformación de Comité es
                        requerida</b>
                    </small>
                  </div>
                </b-form-group>

                <b-form-group class="col-md-6 px-2" label="Número de asistentes" label-for="assistantsNumber">
                  <ValidationProvider name="número de asistentes" :rules="`positive:${employees}`" v-slot="{ errors }">
                    <b-form-input :disabled="!allowAccess() ||
                      (!(getRole('Crear') && committeeID === 0) &&
                        !(getRole('Editar') && committeeID !== 0))
                      " class="form-control" type="number" v-model="coexistenceAct.number_assistants"
                      v-on:change="getPostulatesNumber" required :class="{ 'is-invalid': errors[0] }">
                    </b-form-input>
                    <div v-if="errors">
                      <small class="text-danger">
                        <b>{{ errors[0] }}</b>
                      </small>
                    </div>
                  </ValidationProvider>
                </b-form-group>
              </div>

              <div class="form-row pt-3">
                <b-form-group class="col-md-6 px-2" label="Hora inicio" label-for="beginHour">
                  <b-form-input :disabled="!allowAccess() ||
                    (!(getRole('Crear') && committeeID === 0) &&
                      !(getRole('Editar') && committeeID !== 0))
                    " type="time" id="beginHour" v-model="coexistenceAct.coexistence_begin_hour" :class="{
                      'is-invalid':
                        $v.coexistenceAct.coexistence_begin_hour.$error &&
                        submitted,
                    }">
                    >
                  </b-form-input>
                  <div v-if="submitted && $v.coexistenceAct.coexistence_begin_hour.$error">
                    <small v-if="!$v.coexistenceAct.coexistence_begin_hour.required" class="text-danger">
                      <b>La hora de inicio del acta de conformación de Comité es requerida</b>
                    </small>
                  </div>
                </b-form-group>

                <b-form-group class="col-md-6 px-2" label="Hora cierre" label-for="endingHour">
                  <b-form-input :disabled="!allowAccess() ||
                    (!(getRole('Crear') && committeeID === 0) &&
                      !(getRole('Editar') && committeeID !== 0))
                    " type="time" id="endingHour" v-model="coexistenceAct.coexistence_ending_hour"
                    :class="{ 'is-invalid': $v.coexistenceAct.coexistence_ending_hour.$error && submitted, }">>
                  </b-form-input>
                  <div v-if="submitted &&
                    $v.coexistenceAct.coexistence_ending_hour.$error">
                    <small v-if="!$v.coexistenceAct.coexistence_ending_hour.required" class="text-danger">
                      <b>La hora de cierre del acta de conformación de Comité es requerida</b>
                    </small>
                  </div>
                </b-form-group>
              </div>

              <div class="form-row pt-3">
                <b-form-group class="col-md-12 px-2" label="Lugar" label-for="coexistencePlace">
                  <b-form-textarea :disabled="!allowAccess() ||
                    (!(getRole('Crear') && committeeID === 0) &&
                      !(getRole('Editar') && committeeID !== 0))
                    " type="text" id="coexistencePlace" v-model="coexistenceAct.coexistence_place"
                    :class="{ 'is-invalid': $v.coexistenceAct.coexistence_place.$error && submitted, }">
                    >
                  </b-form-textarea>
                  <div v-if="submitted && $v.coexistenceAct.coexistence_place.$error">
                    <small v-if="!$v.coexistenceAct.coexistence_place.required" class="text-danger">
                      <b>El lugar del acta de conformación de Comité es requerido</b>
                    </small>
                  </div>
                </b-form-group>
              </div>

              <hr />

              <div class="row">
                <div class="col-lg-12">
                  <div class="card-body">
                    <h4>Postulados Empleados</h4>

                    <div class="table-responsive">
                      <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                        <thead>
                          <tr>
                            <th class="text-center">Nombre</th>
                            <th class="text-center">Numero de votos</th>
                            <th class="text-center">Cargo Comité</th>
                            <th class="text-center">Presidente</th>
                            <th class="text-center">Secretario</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="postulate in postulates" :key="postulate.id">
                            <td class="text-left">
                              <div class="row">
                                <div class="col-md-9 col-sm-12 form-control input mx-1">
                                  {{ getName(postulate.employee_id) }}
                                </div>
                                <b-form-select :disabled="!allowAccess() ||
                                  exist ||
                                  (!(getRole('Crear') && committeeID === 0) &&
                                    !(getRole('Editar') && committeeID !== 0))
                                  " @change="filterOptions(postulate.employee_id)"
                                  class="form-control col-md-1 col-sm-12" v-model="postulate.employee_id">
                                  <option v-for="item in candidatesSelect" :value="item.id" :key="item.id">
                                    {{ item.full_name }}
                                  </option>
                                </b-form-select>
                              </div>
                            </td>
                            <td class="text-center">
                              <b-form-input :disabled="!allowAccess() ||
                                (!(getRole('Crear') && committeeID === 0) &&
                                  !(getRole('Editar') && committeeID !== 0))
                                " type="number" class="form-control" v-model="postulate.coexistence_votes">
                              </b-form-input>
                            </td>
                            <td class="text-center">
                              <select :disabled="!allowAccess() ||
                                (!(getRole('Crear') && committeeID === 0) &&
                                  !(getRole('Editar') && committeeID !== 0))
                                " class="form-control" v-model="postulate.coexistence_status"
                                :required="postulate.employee_id">
                                <option :value="0">N/A</option>
                                <option v-for="position in positions" :value="position.id" :key="position.id"
                                  v-on:change="getPositions">
                                  {{ position.name }}
                                </option>
                              </select>
                            </td>
                            <td class="text-center">
                              <b-form-checkbox v-model="postulate.president" name="check-button" switch @change="
                                postulate.president
                                  ? onlyOnePresident(
                                    postulates,
                                    employer,
                                    postulate.id
                                  )
                                  : null
                                ">
                              </b-form-checkbox>
                            </td>
                            <td class="text-center">
                              <b-form-checkbox v-model="postulate.secretary" name="check-button" switch @change="
                                postulate.secretary
                                  ? onlyOneSecretary(
                                    postulates,
                                    employer,
                                    postulate.id
                                  )
                                  : null
                                ">
                              </b-form-checkbox>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- end card -->
                </div>
                <!-- end col -->
              </div>

              <hr />

              <div class="row">
                <div class="col-md-12">
                  <div class="card-body">
                    <h4>Designados del Empleador</h4>
                    <div class="table-responsive">
                      <table class=" mb-0 pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded ">
                        <thead>
                          <tr>
                            <th class="text-center">Nombre</th>
                            <th class="text-center">Cargo Comité</th>
                            <th class="text-center">Presidente</th>
                            <th class="text-center">Secretario</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="emp in employer" :key="emp.id">
                            <td class="text-left">
                              <div class="row">
                                <div class=" col-md-9 col-sm-12 form-control input mx-1 ">
                                  {{ getName(emp.employee_id) }}
                                </div>
                                <b-form-select :disabled="!allowAccess() ||
                                  exist ||
                                  (!(getRole('Crear') && committeeID === 0) &&
                                    !(getRole('Editar') && committeeID !== 0))
                                  " @change="
                                    filterEmployerOptions(emp.employee_id)
                                    " class="form-control col-md-1 col-sm-12" v-model="emp.employee_id">
                                  <option v-for="item in employerCandidates" :value="item.id" :key="item.id">
                                    {{ item.full_name }}
                                  </option>
                                </b-form-select>
                              </div>
                            </td>
                            <td class="text-center">
                              <select :disabled="!allowAccess() ||
                                (!(getRole('Crear') && committeeID === 0) &&
                                  !(getRole('Editar') && committeeID !== 0))
                                " class="form-control" v-model="emp.coexistence_status" :required="emp.employee_id">
                                <option :value="0">N/A</option>
                                <option v-for="position in positionsEmployer" :value="position.id" :key="position.id"
                                  v-on:change="getPositions">
                                  {{ position.name }}
                                </option>
                              </select>
                            </td>

                            <td class="text-center">
                              <b-form-checkbox v-model="emp.president" name="check-button" switch @change="
                                emp.president
                                  ? onlyOnePresident(
                                    employer,
                                    postulates,
                                    emp.id
                                  )
                                  : null
                                ">
                              </b-form-checkbox>
                            </td>
                            <td class="text-center">
                              <b-form-checkbox v-model="emp.secretary" name="check-button" switch @change="
                                emp.secretary
                                  ? onlyOneSecretary(
                                    employer,
                                    postulates,
                                    emp.id
                                  )
                                  : null
                                ">
                              </b-form-checkbox>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <hr />

              <div class="form-row" v-if="committeeID !== 0">
                <b-form-group v-if="committeeID !== 0" class="col-lg-11 col-md-10 col-sm-12 px-2"
                  label="Acta de conformación del comité" label-for="certificateAct">
                  <b-form-file :disabled="!allowAccess() ||
                    (!(getRole('Crear') && committeeID === 0) &&
                      !(getRole('Editar') && committeeID !== 0))
                    " :required="!coexistenceAct.certificate" type="file" id="file" ref="file" name="file"
                    browse-text="Buscar" :placeholder="coexistenceAct.certificate
                      ? getFile(coexistenceAct.certificate)
                      : `Selecciona un archivo...`
                      " drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                    accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                  </b-form-file>
                </b-form-group>
                <b-form-group v-if="committeeID !== 0" class="col-lg-1 col-sm-2 px-2" label="Descargar"
                  label-for="download">
                  <button :disabled="!allowAccess() ||
                    !getRole('Consultar') ||
                    !certificateExist
                    " type="button" :class="`btn ${certificateExist ? 'btn-outline-primary' : 'btn-secondary'} btn-md`"
                    @click="download()">
                    <i class="bx bx-download"></i>
                  </button>
                </b-form-group>
              </div>

              <hr />

              <div class="form-group text-right m-b-0">
                <button :disabled="!allowAccess() ||
                  (!(getRole('Crear') && committeeID === 0) &&
                    !(getRole('Editar') && committeeID !== 0))
                  " type="submit" class="btn btn-primary mx-1">
                  Guardar
                </button>
                <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="text-center">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
        </div>
      </div>
    </div>
  </div>
</template>
